import type { GeneralAction } from './reducer'

import * as types from './actionTypes'

export const setZoomImageUrl = (zoomImageUrl: string | null): GeneralAction => ({
  type: types.SET_ZOOM_IMAGE_URL,
  payload: zoomImageUrl,
})
